/*
  Southern Oaks: Join the House List page (sections/so-house-list.liquid). Movy Media, 2026-10-07.
  Subscribes to the Klaviyo House List with the client subscriptions API (public site id only).
  ?at=<code> records where the QR sign was scanned as the profile property "Signup location".
*/
if (!customElements.get('so-house-list')) {
  customElements.define(
    'so-house-list',
    class SoHouseList extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-form]');
        if (!this.form) return;
        this.emailInput = this.querySelector('[data-email]');
        this.nameInput = this.querySelector('[data-name]');
        this.submitBtn = this.querySelector('[data-submit]');
        this.msg = this.querySelector('[data-msg]');
        this.location = this.readLocation();
        this.form.addEventListener('submit', this.onSubmit.bind(this));
        this.emailInput.addEventListener('input', () => {
          if (this.emailInput.getAttribute('aria-invalid') === 'true') {
            this.emailInput.removeAttribute('aria-invalid');
            this.message('');
          }
        });
      }

      // "market | Farmers market" lines from the section setting; unknown codes are ignored
      readLocation() {
        const code = (new URLSearchParams(window.location.search).get('at') || '').trim().toLowerCase();
        if (!code) return '';
        const match = (this.dataset.locations || '')
          .split('\n')
          .map((line) => line.split('|').map((part) => part.trim()))
          .find(([c]) => c && c.toLowerCase() === code);
        return match && match[1] ? match[1] : '';
      }

      message(kind) {
        this.msg.textContent = kind ? this.msg.dataset[kind] || '' : '';
      }

      // The request on its own, so it can be checked without sending (fetch stubbed in testing)
      request(email, firstName) {
        const properties = { 'House List source': this.dataset.source || 'House List page' };
        if (this.location) properties['Signup location'] = this.location;
        const attributes = {
          email,
          properties,
          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
        };
        if (firstName) attributes.first_name = firstName;
        return {
          url: `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(this.dataset.company || '')}`,
          init: {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', revision: '2026-07-15' },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: this.location ? `${this.dataset.source} - ${this.location}` : this.dataset.source,
                  profile: { data: { type: 'profile', attributes } },
                },
                relationships: { list: { data: { type: 'list', id: this.dataset.list } } },
              },
            }),
          },
        };
      }

      async onSubmit(event) {
        event.preventDefault();
        if (this.busy) return;
        const email = this.emailInput.value.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
          this.emailInput.setAttribute('aria-invalid', 'true');
          this.message('invalid');
          this.emailInput.focus();
          return;
        }
        this.emailInput.removeAttribute('aria-invalid');
        const firstName = this.nameInput ? this.nameInput.value.trim() : '';
        const req = this.request(email, firstName);
        this.busy = true;
        this.submitBtn.setAttribute('aria-busy', 'true');
        this.message('');
        try {
          const res = await fetch(req.url, req.init);
          if (!res.ok) throw new Error(`Klaviyo ${res.status}`);
          this.identify(email);
          this.showDone();
        } catch (e) {
          this.message('error');
        } finally {
          this.busy = false;
          this.submitBtn.removeAttribute('aria-busy');
        }
      }

      // Tell Klaviyo's onsite script who this is, so the welcome popup does not ask again
      identify(email) {
        try {
          if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify({ email });
        } catch (e) {}
      }

      showDone() {
        const formPanel = this.querySelector('[data-panel="form"]');
        const donePanel = this.querySelector('[data-panel="done"]');
        if (!donePanel) return;
        formPanel.hidden = true;
        donePanel.hidden = false;
        const title = this.querySelector('[data-done-title]');
        if (title) title.focus({ preventScroll: true });
        this.scrollIntoView({ block: 'start', behavior: 'auto' });
      }
    }
  );
}
